import React from "react";
import { HiSparkles } from "react-icons/hi2";

import Logo from "./assets/images/logo.webp";
import HovarthiniResume from "./assets/Hovarthini Resume.pdf";
import { NavLink } from "react-router-dom";
const Header = () => {
    const currentUrl = window.location.pathname;

    if (currentUrl.includes("ecom-project")) {
        return (
            <>
                <section className="bg-ecom">
                    <nav className="navbar navbar-expand-lg container">
                        <div className="container-fluid align-items-center">
                            <NavLink to={'/'} className="navbar-brand d-block">
                                <HiSparkles />
                            </NavLink>
                            <div
                                className="align-items-center"
                                id="navbarScroll"
                            >
                                <ul className="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll flex-column">
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to={'/'}>
                                            Home
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to={'/#work'}>
                                            Work
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={HovarthiniResume} target="_blank">
                                            Resume
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </nav>
                </section>
            </>
        );
    } else if (currentUrl.includes("divido-project")) {
        return (
            <>
                <section className="bg-ecom" style={{ backgroundColor: "#FFFDE5" }}>
                    <nav className="navbar navbar-expand-lg container">
                        <div className="container-fluid align-items-center">
                            <NavLink to={'/'} className="navbar-brand d-block">
                                <HiSparkles />
                            </NavLink>
                            <div
                                className="align-items-center"
                                id="navbarScroll"
                            >
                                <ul className="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll flex-column">
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to={'/'}>
                                            Home
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to={'/#work'}>
                                            Work
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={HovarthiniResume} target="_blank">
                                            Resume
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </nav>
                </section>
            </>
        );
    } else if (currentUrl.includes("pixel-project")) {
        return (
            <>
                <section className="bg-ecom" style={{ backgroundColor: "#EFF3FF" }}>
                    <nav className="navbar navbar-expand-lg container">
                        <div className="container-fluid align-items-center">
                            <NavLink to={'/'} className="navbar-brand d-block">
                                <HiSparkles />
                            </NavLink>
                            <div
                            className="align-items-center"
                            id="navbarScroll"
                        >
                            <ul className="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll flex-column">
                                <li className="nav-item">
                                    <NavLink className="nav-link" to={'/'}>
                                        Home
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to={'/#work'}>
                                        Work
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href={HovarthiniResume} target="_blank">
                                        Resume
                                    </a>
                                </li>
                            </ul>
                        </div>
                        </div>
                        
                    </nav>
                </section>
            </>
        );
    } else if (currentUrl.includes("igniteai-project")) {
        return (
            <>
                <section className="bg-ecom" style={{ backgroundColor: "#F2FFEF" }}>
                    <nav className="navbar navbar-expand-lg container">
                        <div className="container-fluid align-items-center">
                            <NavLink to={'/'} className="navbar-brand d-block">
                                <HiSparkles />
                            </NavLink>
                            <div
                            className="align-items-center"
                            id="navbarScroll"
                        >
                            <ul className="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll flex-column">
                                <li className="nav-item">
                                    <NavLink className="nav-link" to={'/'}>
                                        Home
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to={'/#work'}>
                                        Work
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href={HovarthiniResume} target="_blank">
                                        Resume
                                    </a>
                                </li>
                            </ul>
                        </div>
                        </div>
                        
                    </nav>
                </section>
            </>
        );
    }

    return (
        <>
            <nav className="navbar navbar-expand-lg container">
                <div className="container-fluid align-items-center">
                    <NavLink to={'/'} className="navbar-brand d-block">
                        <div className="logo-img">
                            <img className="img-contain" src={Logo} alt="Logo" />
                        </div>
                    </NavLink>

                    <div
                        className=" align-items-center"
                        id="navbarScroll"
                    >
                        <ul className="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll flex-column">
                            <li className="nav-item">
                                <NavLink className="nav-link" to={'/'}>
                                    Home
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href={'/#work'}>
                                    Work
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href={HovarthiniResume} target="_blank">
                                    Resume
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Header;
